angular.module('app').controller('ClassCtrl', function($mdDialog, photo, parent, appUtils, $http, $route, $rootScope, PhotoUtils) {
    "ngInject";

    var main = this;
    main.photoUtils = PhotoUtils;
    main.photo = photo;
    main.parent = parent;
    main.franchiseId = main.parent.franchiseId || $rootScope.franchiseSwitcher.activeFranchise();

    main.event_id = $route.current.params.event_id || main.parent.item.event.id;

    main.selectedClasses = {};

    $http({
        'method': 'GET',
        'url': '/api/v1/admin/event/' + main.event_id + '/class-names'
    }).then(function(response) {
        main.classes = response.data;
    });

    if(main.photo.classes) {
        main.photo.classes.forEach(function(cl) {
            main.selectedClasses[cl.class_name] = true;
        });
    }

    main.save = function() {
        var classes = []
        for(var k in main.selectedClasses) {
            if(main.selectedClasses[k]) {
                classes.push({'class_name': k});
            }
        }
        main.photo.classes = classes
        $mdDialog.hide();
    };

    main.cancel = $mdDialog.cancel;

});
